import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { BREAKPOINTS } from "../../constants";
import MobileLayout from "./MobileLayout";
import DesktopLayout from "./DesktopLayout";
import { ROUTES } from "./contants";

export default function Setting() {
  const portal = useSelector((state) => state.auth?.portal);
  const [route, setRoute] = useState(ROUTES.CHANGE_PASSWORD);
  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= BREAKPOINTS.MOBILE
  );

  useEffect(() => {
    if (portal === "agent" && route !== ROUTES.CHANGE_PASSWORD) {
      setRoute(ROUTES.CHANGE_PASSWORD);
    }
  }, [portal, route, setRoute]);

  useEffect(() => {
    function handleWindowSizeChange() {
      setIsMobile(window.innerWidth <= BREAKPOINTS.MOBILE);
    }
    window.addEventListener("resize", handleWindowSizeChange);
    return () =>
      window.removeEventListener("resize", handleWindowSizeChange);
  }, []);

  return isMobile ? (
    <MobileLayout route={route} setRoute={setRoute} />
  ) : (
    <DesktopLayout route={route} setRoute={setRoute} />
  );
}
